import React from 'react';
import { cn } from './cn';
import { Breadcrumb } from './Breadcrumb';

/**
 * PageHeader — tiêu đề trang chuẩn: breadcrumb (tuỳ chọn) + title + description + actions.
 */
export function PageHeader({ title, description, actions, breadcrumb, icon: Icon, className }) {
  return (
    <div className={cn('mb-6', className)}>
      {breadcrumb?.length ? <Breadcrumb items={breadcrumb} className="mb-2" /> : null}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          {Icon ? (
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-brand-softer text-brand-fg-strong flex-shrink-0">
              <Icon className="w-5 h-5" aria-hidden="true" />
            </span>
          ) : null}
          <div className="min-w-0">
            <h1 className="text-xl sm:text-2xl font-bold text-heading truncate">{title}</h1>
            {description ? <p className="text-sm text-muted mt-0.5">{description}</p> : null}
          </div>
        </div>
        {actions ? <div className="flex items-center gap-2 flex-shrink-0">{actions}</div> : null}
      </div>
    </div>
  );
}

export default PageHeader;
